// extracted by mini-css-extract-plugin
module.exports = {"body":"ClientEdit_body__1GyzW","container":"ClientEdit_container__26i5k","div":"ClientEdit_div__1wcYL","h2":"ClientEdit_h2__3k9Tp","form":"ClientEdit_form__1nP9R"};